<template>
  <div class="home">
    <button class='menuButtons' @click="toggleShowModal"><i class="fas fa-plus"></i> Add</button>
    <!-- <button class='menuButtons' @click="$store.dispatch('submitDeviceListToDB')"><i class="fas fa-sync"></i> Save Changes</button> -->
    <span v-show="selectedDevices!=0" class="extraButtons">
      <button class='menuButtons' @click="updateSelectedDevices">
        <i class="fa-solid fa-arrow-rotate-right"></i> Chargd
      </button>
      <button class='menuButtons' @click="removeSelectedDevices">
        <i class="fa-solid fa-trash"></i> Delete
      </button>
    </span>
    <DeviceForm v-if="showModal" @close="toggleShowModal"/>
    <DeviceList id='devicelist' v-if="$store.getters.currentUser"/>
  </div>
</template>

<script>
import DeviceList from '../components/DeviceList.vue'
import DeviceForm from '../components/DeviceForm.vue'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'Home',
  components: { DeviceList, DeviceForm },

  setup(){
    const showModal = ref(false)
    const store = useStore()
    const userDeviceList = computed(() => store.state.deviceList)
    const selectedDevices = computed(() => store.state.deviceList.filter((device) => {return device.selected}))

    const toggleShowModal = (() => {
      showModal.value = !showModal.value
      
    })

    const updateSelectedDevices = (() => {
      selectedDevices.value.forEach(device => {
        store.dispatch('resetDeviceDate', device)
        device.selected = false
      })
    })

    const removeSelectedDevices = (() => {
      selectedDevices.value.forEach(device => {
        store.commit('removeDevice', device)
      })
    })

    

    return {
      showModal,
      toggleShowModal,
      userDeviceList,
      selectedDevices,
      updateSelectedDevices,
      removeSelectedDevices
    }
  },

  // watch: {
  //   userDeviceList: {
  //     // handler(newValue, oldValue) {
  //     handler(){
  //       this.$store.dispatch('submitDeviceListToDB')
  //     },
  //     deep: true
  //   }
  // }
}
</script>

<style scoped>
.menuButtons {
  margin-top: 1em;
  margin-left: 1.5em;
}

.menuButtons {
  border: 0;
  padding: 10px 20px;
  color: white;
  border-radius: 20px;
  cursor: pointer;
  text-align:center;
  border: none;
  background-size: 300% 100%;
  -moz-transition: all .4s ease-in-out;
  -o-transition: all .4s ease-in-out;
  -webkit-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
  font-size: 16px;
  font-weight: 600;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.menuButtons:hover {
    background-position: 100% 0;
    -moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}

.menuButtons:focus {
    outline: none;
}

.menuButtons {
    background-image: linear-gradient(to right, #25aae1, #40e495, #30dd8a, #1ba098);
    box-shadow: 0 4px 15px 0 rgba(49, 196, 190, 0.75);
}
</style>
